import { Link } from 'react-router-dom';

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
            {/* Text */}
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-6">
                <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  Buyer Testimonial
                </span>
              </div>
              <blockquote className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-950 leading-relaxed italic">
                &ldquo;VigorBuy helped me skip the guesswork. The spreadsheet is organized, honest, and genuinely speeds up every purchase decision I make.&rdquo;
              </blockquote>
              <div className="mt-6 flex items-center gap-3">
                <span className="text-base font-semibold text-foreground-900">Jordan T.</span>
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-verified-badge-line text-lg text-primary-600"></i>
                </span>
                <span className="text-sm text-foreground-500">Verified Buyer</span>
              </div>
              <Link
                to="/article/best-vigorbuy-spreadsheet-products"
                className="inline-flex items-center gap-1 mt-6 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                Read more success stories <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Portrait */}
            <div className="flex-1 flex justify-center">
              <div className="w-64 h-80 md:w-80 md:h-96 rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Confident%20young%20professional%20woman%20in%20modern%20beige%20blazer%20leaning%20against%20minimal%20concrete%20wall%20with%20dramatic%20natural%20side%20lighting%20from%20floor%20to%20ceiling%20window%20creating%20artistic%20shadows%20urban%20loft%20aesthetic%20editorial%20portrait%20photography%20with%20warm%20neutral%20tones%20shallow%20depth%20of%20field%20high%20quality%20fashion%20editorial%20style&width=700&height=900&seq=testimonial-portrait-v3&orientation=portrait"
                  alt="Satisfied VigorBuy Spreadsheet user testimonial"
                  title="VigorBuy Spreadsheet user testimonial"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}